import request from '../request'

// 接口日志模块

export default {
  // 分页获取职位列表
  getJobList: (data) => {
    return request({
      url: '/beisen/Hilton433388-Recruitment-HiltonRecruit/api/JobAd/GetJobAdList',
      method: 'post',
      data
    })
  },
  // 获取地图列表
  getMapJobList: (data)=>{
    return request({
      url: '/beisen/Hilton433388-Recruitment-HiltonRecruit/api/JobAd/GetJobAdListByCoordinates',
      method: 'post',
      data
    })
  },
  getJobDetail: (id) =>{
    return request({
      url: `/beisen/Hilton433388-Recruitment-HiltonRecruit/api/JobAd/GetJobAdById?jobAdId=${id}`,
      method: 'get',
    })
  },
  // 获取省市区信息
  getPrivoceCity: () =>{
    return request({
      url: '/beisen/Hilton433388-Recruitment-HiltonRecruit/api/jobAd/GetCity',
      method: 'post',
    })
  },
  // 获取职位分类 2
  getJobCategory: (jobCategory) =>{
    return request({
      url: `/beisen/Hilton433388-Recruitment-HiltonRecruit/api/JobAd/GetJobCategoryList?jobCategory=${jobCategory}`,
      method: 'get',
    })
  },
  // 获取酒店品牌对象
  getHotelBrandObj: () =>{
    return request({
      url: '/beisen/Hilton433388-Recruitment-HiltonRecruit/api/jobAd/GetHotel',
      method: 'post',
    })
  }
}
